export type ApprovalSequenceSummary = {
  id: string;
  company: { id: string; name: string };
  report: string;
};

export type ApprovalSequenceMember = {
  id: string;
  step: number;
  access: {
    id: string;
    role?: string;
    user?: string;
  };
  assignee?: { id: string; name: string };
};

export type ApprovalSequence = ApprovalSequenceSummary & {
  members: ApprovalSequenceMember[];
};

export type Member = {
  id: string;
  name: string;
  assigneeId?: string;
};

export type SequenceStep = { step: number; members: Member[] };

export type ApprovalSequenceFormFields = {
  company: string;
  report: string;
  sequence: SequenceStep[];
};

export enum AccessType {
  user = 'user',
  role = 'role',
}

export enum ApprovalAction {
  approve = 'approve',
  reject = 'reject',
}

export type Approval = {
  id: string;
  step: number;
  user: { id: string; userName: string };
  createdAt: Date;
  action: ApprovalAction;
};

export type ASFilterFields = 'companies' | 'report';
